var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCashCode128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5551 14H44.6665C40.0642 14 36.3333 17.7309 36.3333 22.3333V105.666C36.3333 110.268 40.0642 113.999 44.6665 113.999H83.5551C88.1574 113.999 91.8884 110.268 91.8884 105.666V22.3333C91.8884 17.7309 88.1574 14 83.5551 14Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5551 14H44.6665C40.0642 14 36.3333 17.7309 36.3333 22.3333V105.666C36.3333 110.268 40.0642 113.999 44.6665 113.999H83.5551C88.1574 113.999 91.8884 110.268 91.8884 105.666V22.3333C91.8884 17.7309 88.1574 14 83.5551 14Z",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.333 99.7148H91.8881V105.667C91.8881 110.27 88.1572 114 83.5549 114H44.6663C40.0639 114 36.333 110.27 36.333 105.667V99.7148Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1112 110.427C66.1122 110.427 67.7344 108.828 67.7344 106.856C67.7344 104.883 66.1122 103.284 64.1112 103.284C62.1102 103.284 60.488 104.883 60.488 106.856C60.488 108.828 62.1102 110.427 64.1112 110.427Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 30.667,
    width: 72.2217,
    height: 24.9998,
    rx: 2,
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.6665,
    y: 66.7773,
    width: 38.8886,
    height: 19.4443,
    rx: 2,
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.333 36.2217L44.6663 48.7216",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6663 36.2217L36.333 48.7216",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1387 36.2217L56.4719 48.7216",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4717 36.2217L48.1384 48.7216",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9438 36.2217L68.2771 48.7216",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2773 36.2217L59.9441 48.7216",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7495 36.2217L80.0828 48.7216",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0825 36.2217L71.7493 48.7216",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5552 36.2217L91.8884 48.7216",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8882 36.2217L83.5549 48.7216",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1423,
    cy: 76.4994,
    r: 2.77776,
    fill: "#1E1E1E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.2738,
    cy: 76.4994,
    r: 2.77776,
    fill: "#1E1E1E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.4054,
    cy: 76.4994,
    r: 2.77776,
    fill: "#1E1E1E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5368,
    cy: 76.4994,
    r: 2.77776,
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCashCode128);
export default __webpack_public_path__ + "static/media/pictogramBeaconCashCode128.92ead55c663efc9c976603d618b5e8bf.svg";
export { ForwardRef as ReactComponent };